import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Info } from "@mui/icons-material";
import { useCallback } from "react";

export default function SDGInfoButton({ ...props }) {
  const navigate = useNavigate();
  const navToSDGGoals = useCallback(() => navigate("/Sustainable-Development-Goals"), [navigate]);
  return (
    <IconButton sx={{ padding: 0, marginTop: -0.5, marginLeft: 1 }} onClick={navToSDGGoals} {...props}>
      <Info sx={{ fontSize: 16, color: "primary.main" }} />
    </IconButton>
  );
}
